import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const STILL_VEHICLE_OWNER = {
  YES: 'yes',
  NO: 'no',
} as const;

export const STILL_VEHICLE_OWNER_NAME = 'still_vehicle_owner';
export const STILL_VEHICLE_OWNER_NAME_COMPLEMENTARY =
  'still_vehicle_owner_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupVehicleOwner: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? STILL_VEHICLE_OWNER_NAME_COMPLEMENTARY
      : STILL_VEHICLE_OWNER_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy nadal jesteś właścicielem samochodu?')}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-still-vehicle-owner"
            >
              <RadioItem
                value={STILL_VEHICLE_OWNER.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-still-vehicle-owner-yes"
              />
              <RadioItem
                value={STILL_VEHICLE_OWNER.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-still-vehicle-owner-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
